import common from './common.en-US';
import formDetail from '../views/form/locale/en-US';
import flowCenter from '@cloudpivot/flow-center/locales/en-US';
import list from '@cloudpivot/list/locales/en-US';
import flow from '@cloudpivot/flow/locales/en-US';
import formComment from '@cloudpivot/form-comment/locales/en-US';
import form from '@cloudpivot/form/locales/en-US';
import application from '@cloudpivot/application/locales/en-US';
import cloudpivotCommon from '@cloudpivot/common/locales/en-US';
export default {
    cloudpivot: {
        flowCenter,
        list,
        flow,
        formComment,
        form,
        application,
        all: require('@cloudpivot/common/locales/machine/en-US.json'),
        cloudpivotCommon
    },
    languages: {
        common,
        form: formDetail
    }
};
